import { injectable, inject } from 'inversify';
import { Scorm2004QuestionDataStore, Scorm2004QuestionDetails } from './scorm2004-question-data-store';
import { QueryHandler } from '@/app/tracking/common';
import { QueryQuestionsTrackingQuery, QueryQuestionsTrackingQueryPayload, QuestionState } from '../api';
import { defaultQuestionState } from '../tincan/question-state';
import { reportNonFatalError } from '@/app/error-handling';

@injectable()
export class Scorm2004QueryQuestionsQueryHandler implements QueryHandler<QueryQuestionsTrackingQuery> {

  constructor(
    @inject(Scorm2004QuestionDataStore)
    private store: Scorm2004QuestionDataStore) {
  }

  public async execute(payload: QueryQuestionsTrackingQueryPayload) {

    const result: QuestionState[] = [];

    for (const id of payload.ids) {
      const all = await this.store.queryAll(id);
      if (!all.success) {
        result.push(defaultQuestionState(id))
        reportNonFatalError(`Error while querying question with id '${id}'`, all.error)
        continue
      }

      result.push(map(id, all.value));
    }

    return {
      questions: result
    }

    function map(id: string, details: Scorm2004QuestionDetails[]): QuestionState {
      return {
        id,
        attempts: details.map((item) => ({
          timestamp: item.timestamp,
          response: item.response,
          score: item.score,
          durationSeconds: item.durationSeconds
        }))
      };
    }
  }
}
